module.exports = __webpack_public_path__ + "static/media/Invest_In_Home.ee2167ec.jpg";